import { ComponentProps } from 'react';
import { CONTACT_US_LINK } from 'constants/links';
import { twMerge } from 'tailwind-merge';

interface SubscriptionFaqsProps extends ComponentProps<'div'> {}
const SubscriptionFaqs = ({ className, ...rest }: SubscriptionFaqsProps) => {
    return (
        <div className={twMerge('flex flex-col gap-4', className)} {...rest}>
            <div className="text-2xl font-medium">FAQs</div>
            <div className="grid grid-cols-1 gap-10 text-sm">
                <div className="flex flex-col gap-2">
                    <h3 className="text-lg font-medium">
                        Will I be charged for contacts in the free Givebutter CRM?
                    </h3>
                    <p className="text-gray-600">
                        You will never be required to upgrade or pay for contacts in the free
                        Givebutter CRM. Contact-based pricing applies only to Givebutter Plus
                        subscribers.
                    </p>
                </div>
                <div className="flex flex-col gap-2">
                    <h3 className="text-lg font-medium">What is Givebutter Plus?</h3>
                    <p className="text-gray-600">
                        Givebutter Plus brings together our platform’s free fundraising, marketing,
                        and CRM software, PLUS advanced features like automated workflows, data
                        hygiene, custom reports, and an advanced email editor.
                    </p>
                </div>
                <div className="flex flex-col gap-2">
                    <h3 className="text-lg font-medium">Is there a free trial available?</h3>
                    <p className="text-gray-600">
                        We offer a 30-day free trial of Givebutter Plus that can be started at any
                        time, no credit card required.
                    </p>
                </div>
                <div className="flex flex-col gap-2">
                    <h3 className="text-lg font-medium">How does billing work?</h3>
                    <p className="text-gray-600">
                        All billing for Givebutter Plus is managed through our partner, Stripe.
                        Yearly subscriptions are billed annually on the same day of the month you
                        subscribed. Monthly subscriptions are billed on the same day each month.
                    </p>
                </div>
                <div className="flex flex-col gap-2">
                    <h3 className="text-lg font-medium">What are overages?</h3>
                    <p className="text-gray-600">
                        Overage fees are additional charges that apply to your monthly bill if you
                        exceed the number of contacts allowed in your tier. For example, if your
                        organization had 3,000 contacts, you would pay $149 each month + $35 for
                        your 500 extract contacts for a total of $184 per month.
                    </p>
                </div>
                <div className="flex flex-col gap-2">
                    <h3 className="text-lg font-medium">Can I cancel my subscription?</h3>
                    <p className="text-gray-600">
                        You can cancel anytime, and your subscription will remain active until the
                        end of your subscription period.
                    </p>
                    <p className="text-gray-600">
                        If you change your mind you can renew your subscription from the
                        Subscription & Billing page. If renewed, you will be billed at the end of
                        your current subscription period.
                    </p>
                </div>
                <div className="flex flex-col gap-2">
                    <h3 className="text-lg font-medium">What if I don’t like Givebutter Plus?</h3>
                    <p className="text-gray-600">
                        If you’re not satisfied with Givebutter Plus, please{' '}
                        <a
                            href={CONTACT_US_LINK}
                            target="_blank"
                            rel="noreferrer"
                            className="text-gray-600 underline"
                        >
                            contact our support team
                        </a>{' '}
                        for assistance.
                    </p>
                </div>
                <div className="flex flex-col gap-2">
                    <h3 className="text-lg font-medium">
                        What happens if I exceed the number of contacts in my plan during a billing
                        cycle?
                    </h3>

                    <p className="text-gray-600">
                        For annual plans, you will be charged immediately when you have an overage.
                        This will be prorated for the remainder of your subscription period.
                    </p>
                    <p className="text-gray-600">
                        For monthly plans, your next bill will include a prorated charge for the
                        overage and the monthly overage charge for the upcoming subscription period.
                    </p>
                </div>
            </div>
        </div>
    );
};

export { SubscriptionFaqs };
